import useSWRV from 'swrv'
import { onMounted } from 'vue'
import { router } from '@inertiajs/vue3'
import { useProgressBar } from './useProgressBar'

/**
 * A composable that reloads the authenticated user's data at regular intervals.
 * It will only fetch once every `refreshInterval` milliseconds, unless paused.
 * It can be used in multiple components without causing redundant requests.
 *
 * @returns {Object} An object containing `pause` and `start` methods to control the reloader.
 */
export function useAuthReloader() {
    const refreshInterval = 5000
    const { hideProgress, showProgress } = useProgressBar()

    function pause() {
        window.useReloaderPause = true
    }

    function start() {
        window.useReloaderPause = false
    }

    function canFetch() {
        return (
            !window.useReloaderPause &&
            (window.lastTimeFetchedReloader
                ? window.lastTimeFetchedReloader + refreshInterval < Date.now()
                : true)
        )
    }
    // Fetch user profile
    const fetcher = () => {
        if (canFetch()) {
            window.lastTimeFetchedReloader = Date.now()
            return router.reload({ only: ['auth'] })
        }
        return null
    }

    useSWRV('/inertia-user-reload', fetcher, { refreshInterval: 5000 })

    onMounted(() => {
        hideProgress()
    })

    return {
        pause,
        start,
    }
}
